module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hi"
  }, [_vm._v("\n  Hi Vue!\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c1df5ed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SayHi.vue
// module id = 64
// module chunks = 0